<template>
  <nav ref="tabBar" :class="navClasses">
    <a class="mui-tab"
      role="tab"
      v-for="key in Object.keys(panels)"
      :key="key"
      :class="{ 'mui-tab--active': panel === key }"
      @click="$emit('push', key)">{{panels[key].name}}</a>
    <span
      class="mui-tab-bar__indicator"
      :style="indicatorStyles" />
  </nav>
</template>

<script>
export default {
  name: 'mui-tab-bar',
  props: [
    'fixed',
    'panel',
    'panels',
    'scrolled',
    'width'
  ],
  computed: {
    navClasses () {
      return {
        'mui-tab-bar': true,
        'mui-tab-bar--fixed': this.fixed,
        'mui-tab-bar--scrolled': this.scrolled
      }
    },
    indicatorStyles () {
      const numberPanels = Object.keys(this.panels).length
      const position = this.panels[this.panel].position * 100 / numberPanels
      const scale = 1 / numberPanels
      return { transform: `translateX(${position}%) scale(${scale}, 1)` }
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-tab-bar
  background: $white
  display: table
  position: relative
  height: 48px
  margin: 0
  user-select: none
  width: 100%
  &:after
    content: ''
    display: block
    position: absolute
    left: 0
    top: 48px
    width: 100%
    height: 10px
    opacity: 0
    pointer-events: none
    box-shadow: inset 0 2px 5px -3px rgba(0,0,0,0.24)
    transition: all $sheetSpeed/2 $animationTimingFunction
.mui-tab-bar--fixed
  top: 0
  margin-top: 61px
  position: fixed
  background: $white
  z-index: 100
  &.mui-tab-bar--scrolled:after
    opacity: 1
.mui-tab-bar-shim
  height: 48px
.mui-tab-bar-shim--active
  display: block
.mui-tab
  font-size: 0.875rem
  font-weight: 500
  font-family: $uiFontFamily
  text-transform: uppercase
  display: table-cell
  position: relative
  min-width: 124px
  min-height: 48px
  padding: 0
  text-align: center
  white-space: nowrap
  cursor: pointer
  overflow: hidden
  pointer-events: auto
  vertical-align: middle
  color: $subtleTextColor
  border-bottom: 1px solid rgba(0, 0, 0, 0.12)
.mui-tab--active
  color: rgba(0, 0, 0, 0.87)
.mui-tab-bar__indicator
  position: absolute
  bottom: 0
  left: 0
  width: 100%
  height: 1px
  background-color: rgba(0, 0, 0, 0.87)
  transform-origin: left top
  transition: -webkit-transform 240ms 0ms cubic-bezier(0, 0, 0.2, 1)
  transition: transform 240ms 0ms cubic-bezier(0, 0, 0.2, 1)
  transition: transform 240ms 0ms cubic-bezier(0, 0, 0.2, 1), -webkit-transform 240ms 0ms cubic-bezier(0, 0, 0.2, 1)
  will-change: transform
</style>



// WEBPACK FOOTER //
// src/components/MUITabBar.vue